<article class="card glassmorphism">
  <h2 class="card-title">{{ title }}</h2>
  <p class="card-description">{{ description }}</p>
  <app-button [text]="button.text" [link]="button.link" [type]="button.type"></app-button>
</article>
